import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { cachedSetEnergyKwickKpiDataCommunityRanking } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

export const EnergyKwickCommunityRankingResolver = () => {
  
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const calendar = useSelector((state: any) => state.calendar);
  const metadata = useSelector((state: any) => state.metadata);
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!location.pathname.includes('community')) { return; }

    const COMMUNITY_ID = params?.id || metadata?.selectedEntity?.communityId || null;

    if (!COMMUNITY_ID) { return; }

    // Token auto-injected by httpService interceptor
    dispatch(cachedSetEnergyKwickKpiDataCommunityRanking({COMMUNITY_ID, selectedDate, selectedTimeSet} as any) as any);
  }

  useEffect(() => {
    init();
  }, [selectedDate, pathSegment, params?.id]);

  return <></>;
};
